var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"data-vue-component-name":"ProgressBar","value":_vm.value,"rounded":"","height":"12","background-color":"secondary","color":"progressBar"}})}
var staticRenderFns = []

export { render, staticRenderFns }